import * as React from "react";
import styled from "styled-components";
import queryString from "query-string-for-all";
import { NavLink } from "react-router-dom";
import { I18n } from "@lingui/react";
import {
  PrimaryNavLink as NavItem,
  color,
  ControlGroup,
} from "@conserveit/blocks";
import { history } from "../../../browserHistory";

interface NavProps {
  links: Array<{ href: string; label: any }>;
  className?: string;
}

// NavItem styling below is for the active Insights/Action/Reports button

export const MenuItem = styled(NavItem)`
  &.is-active {
    background-color: ${color.theme.primaryNav.state.currentActive.background};
  }
`;

export const PrimaryNav: React.FunctionComponent<NavProps> = ({ links }) => {
  const [siteIdsSuffix, setSiteIdsSuffix] = React.useState<string | null>(null);

  React.useEffect(() => {
    const qs = queryString.parse(history.location.search);
    if ("sites" in qs) {
      const siteIdsFromUrl = qs.sites;
      const parsedSiteIdsFromUrl = queryString.stringify({
        sites: siteIdsFromUrl,
      });
      setSiteIdsSuffix(parsedSiteIdsFromUrl);
    }
  });

  return (
    <I18n>
      {({ i18n }) => (
        <ControlGroup extraTight>
          {links.map(({ href, label }) => (
            // @ts-ignore
            <MenuItem
              as={NavLink}
              key={href}
              activeClassName="is-active"
              data-cy="PrimaryNav-item"
              to={
                siteIdsSuffix ? { pathname: href, search: siteIdsSuffix } : href
              }
              href={href}
            >
              {label(i18n)}
            </MenuItem>
          ))}
        </ControlGroup>
      )}
    </I18n>
  );
};

PrimaryNav.defaultProps = {
  className: "",
};
